import React, { useState } from 'react';
import ProductCard from './ProductCard';
import '../../assets/css/store/product_grid.css';
import prod_image from '../../assets/images/prod_img.png';

const ProductGrid = ({ products, onAddToCart, convertPrice }) => {
    const [selectedProduct, setSelectedProduct] = useState(null);

    return (
        <div className="product-grid">
            {products.map(product => (
                <ProductCard
                    key={product.id}
                    product={product}
                    onAddToCart={onAddToCart}
                    onClick={() => setSelectedProduct(product)}
                    convertPrice={convertPrice}
                />
            ))}
            {selectedProduct && (
                <div className="product-modal">
                    <div className="modal-content">
                        <h2>{selectedProduct.name}</h2>
                        {/* <img src={selectedProduct.image} alt={selectedProduct.name} /> */}
                        <img src={prod_image} alt={selectedProduct.name} />
                        <p>{selectedProduct.description}</p>
                        <button onClick={() => setSelectedProduct(null)}>Close</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProductGrid;